/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { Component } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    IconButton,
    Grid,
    Typography,
    FormControl,
    FormControlLabel,
    Radio,
    RadioGroup,
    FormHelperText,
    CircularProgress,
} from '@material-ui/core';

import CloseIcon from '@material-ui/icons/Close';
import { withStyles } from '@material-ui/core/styles';
import {
    shape, string, object, func, arrayOf, bool,
} from 'prop-types';
import { connect } from 'react-redux';
import mbpLogger from 'mbp-logger';
import { differenceInDays } from 'date-fns';
import { withRouter } from 'react-router';
import { enterpriseCSS } from '../../../../style/variables';
import EventDispatcher from '../../../../state/reducers/EventDispatcher';
import configENV from '../../../../config';
import { isEmpty } from '../../../../utils/object';
import { getSSRDeviceType } from '../../../../../../../state/ducks/App/App-Selectors';
import customBreakpoints from '../../../../../../helpers/customBreakpoints';
import Helper from '../../../../../Account/state/reducers/Helper';

const { PERSIST_KEY } = configENV;

const styles = (theme) => ({
    modalTitle: {
        fontSize: '20px',
        fontWeight: 'bold',
        textAlign: 'center',
    },
    modalTitleContainer: {
        backgroundColor: theme.palette.colorNeutral40,
        padding: 0,
    },
    modalBodyText: {
        padding: '5px 15px 5px 0',
        fontSize: '18px',
        color: 'black',
        marginBottom: '0px',
        [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
            fontSize: '16px',
            padding: '0px 5px',
        },
    },
    closeButton: {
        position: 'absolute',
        top: '5px',
        right: '10px',
    },
    buttonsWrapper: {
        margin: '10px auto',
        paddingBottom: '5px',
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
        [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
            margin: '15px 0',
            justifyContent: 'space-evenly',
        },
    },
    cancelButton: {
        padding: '10px 25px',
        margin: '0 10px',
        background: theme.palette.common.white,
        cursor: 'pointer',
        color: theme.palette.grey3,
        border: `1px solid ${theme.palette.grey3}`,
        width: '45%',
        fontSize: 14,
        [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
            borderRadius: '50px',
            margin: 0,
            padding: '10px',
        },
    },
    CTAButton: {
        padding: '10px 25px',
        margin: '0 10px',
        background: enterpriseCSS.palette.blue,
        color: theme.palette.common.white,
        border: 0,
        cursor: 'pointer',
        fontSize: 14,
        width: '45%',
        [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
            borderRadius: '50px',
            margin: 0,
            padding: '10px',
        },
    },
    modalContentContainer: {
        height: '400px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
            padding: '8px',
        },
    },
    modalInnerContent: {
        marginLeft: '20px',
        position: 'relative',
    },
    radioButtons: {
        fontSize: '18px',
    },
    radioButtonsPage1: {
        fontSize: '18px',
        [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
            fontSize: '16px',
            marginBottom: '10px',
        },
    },
    validationMsg: {
        color: 'red',
        fontSize: '14px',
        margin: '0px',
        [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
         paddingLeft: '5px',
     },
    },
    loaderContainer: {
        margin: 'auto',
    },
    errorIconWrap: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: '4vh',
    },
    errorIcon: {
        width: '80.76px',
    },
});

/*  An order must meet all of the following conditions in order to be eligible:
        1. 18F order
        2. single item order
        3. delivered
        4. this order is not to buy passport
        5. has not been replaced before
    // page flow
    // page 1 = intro page confirming user wants to replace their order.
    // page 2 = 'what type of product had an issue?' - flowers, food, container
    // page 3 = 'what was the issue? - broken / torn, dirty / stained
    // page 4 = 'was the shipping box damaged?' - yes / no
    // only GPT products have shipping box, which corresponds to page 4. No need to show page 4 for FPT items.
    // issues with flower products do not need any further questions, they will be replaced regardless so no need to prompt further.

     if (productType === 'FPT') {
         switch (issueProductType) {
             case 'floral':
                 return ['page1', 'page2', 'resolution'];
             case 'container':
                 return ['page1', 'page2', 'page3', 'resolution'];
             case 'food':
                 return ['page1', 'page2', 'page3', 'resolution'];
             default:
                 break;
         }
     }
     if (productType === 'GPT') {
         switch (issueProductType) {
             case 'floral':
                 return ['page1', 'page2', 'page4', 'resolution'];
             case 'container':
                 return ['page1', 'page2', 'page3', 'page4', 'resolution'];
             case 'food':
                 return ['page1', 'page2', 'page3', 'page4', 'resolution'];
             default:
                 break;
         }
     }
 } */
class ReplacementOrderModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            page0: false,
            page1: false,
            page2: false,
            page3: false,
            page4: false,
            customerService: false,
            error: '',
            issueResolution: '', // replacement, 50% refund + $20 savings pass
            issueProductType: '', // floral, container, food
            productIssue: '', // broken, torn, expired, etc
            shippingDamaged: '',
            validationFailed: false,
            isLoading: true,
        };
    }

    componentDidMount() {
        const {
            ROSSOrder, checkProductAvailability, isAvailable, availabilityError
        } = this.props;

        const checkProductAvailable = async () => {
            const payload = {
                zipCode: ROSSOrder.recipientProfiles[0].addressDetail[0].zipCode,
                productSku: ROSSOrder.items[0].productSku,
                locationType: ROSSOrder.recipientProfiles[0].addressDetail[0].addressType,
                brandCode: ROSSOrder.items[0].productBrand,
                promCode: '',
            };
            await checkProductAvailability(payload);
        };
        checkProductAvailable();
        // handle accidental close of modal before submit
        if (isAvailable === true || isAvailable === false) {
            this.setState({ page0: true, isLoading: false });
        }

        if (availabilityError) {
            this.setState({ isLoading: false, error: 'generic' });
        }
    }

    componentDidUpdate(prevProps) {
        const {
            isAvailable, availabilityError, isPartialCreditEnabled, isReplacementEnabled, ROSSCSIFailureReason,
        } = this.props;
        const { hasExceededCSIMinCharge } = ROSSCSIFailureReason;

        // If true - Order is <= 20
        // If false - Order is >= 20
        const isOrderOver20 = hasExceededCSIMinCharge === false;

        if (isPartialCreditEnabled && isReplacementEnabled && !availabilityError) {
            // Render product not available screen for savings pass scenario where product not available and below $20
            if (isOrderOver20 === false && isAvailable === false && prevProps.isAvailable === null) {
                this.setState({
                    error: 'product not available', isLoading: false,
                });
            }
            // Render page 1 for savings pass scenario where order is over 20 and product not available
            if (isOrderOver20 === true && isAvailable === false && prevProps.isAvailable === null) {
                this.setState({ isLoading: false, page0: true });
            }
            // Render page 1 if product is available and show both options
            if (isAvailable === true && prevProps.isAvailable === null) {
                this.setState({ isLoading: false, page0: true });
            }
        }

        if (isPartialCreditEnabled && !isReplacementEnabled && !availabilityError) {
            // Render page 1 with partial credit only if replacement is off
            if ((isAvailable === true || isAvailable === false) && prevProps.isAvailable === null) {
                this.setState({ isLoading: false, page0: true });
            }
        }

        if (isReplacementEnabled && !isPartialCreditEnabled && !availabilityError) {
            // Render sorry page if replacement enabled and product not available
            if (isAvailable === false && prevProps.isAvailable === null) {
                this.setState({
                    error: 'product not available', isLoading: false,
                });
            }
            // Render page 1 with partial credit only if replacement is off
            if (isAvailable === true && prevProps.isAvailable === null) {
                this.setState({ isLoading: false, page0: true });
            }
        }

        // Fallback to error page if check availability fails
        if (availabilityError && !prevProps.availabilityError) {
            this.setState({
                error: 'generic', isLoading: false,
            });
        }
    }

    handleClickProceed = (currentPage, nextPage, stateToClear) => {
        this.setState({
            [currentPage]: false,
            [nextPage]: true,
            [stateToClear]: '',
        });
    }

    handleSelectValue = (event) => {
        const selectedValue = event.target.value.split(':'); // ex: 'issueProductType:floral' => ['issueProductType', 'floral']
        const stateType = selectedValue[0]; // ex: 'issueProductType'
        const value = selectedValue[1]; // ex: 'floral'
        this.setState({
            [stateType]: value,
            validationFailed: false,
        });
    }

    handleValidateSelection = () => {
        // checks whether user has a selected a radio button
        const {
            page1,
            issueResolution,
            page2,
            issueProductType,
            page3,
            productIssue,
            page4,
            shippingDamaged,
        } = this.state;
        if (page1 && issueResolution !== '') {
            return true;
        }
        if (page2 && issueProductType !== '') {
            return true;
        }
        if (page3 && productIssue !== '') {
            return true;
        }
        if (page4 && shippingDamaged !== '') {
            return true;
        }
        this.setState({ validationFailed: true });
        return null;
    }

    handleSubmit = async () => {
        const { replaceOrder, isAvailable } = this.props;

        this.setState({
            isLoading: true,
        });

        if (isAvailable) {
            const payload = this.generateReplacementPayload();
            await replaceOrder(payload);
        }
    }

    handlePartialRefund = async () => {
        const { partialRefund } = this.props;
        this.setState({
            isLoading: true,
        });
        // Generate Payload to send to BE
        const payload = this.generateSavingsPassPayload();
        // Send payload to BE to process partial credit
        await partialRefund(payload);
    }

    renderHeaderComponent = (classes) => {
        const {
            handleChangeModalState, replaceResponse, partialRefundResponse, partialRefundResponseError, history, isAvailable,
        } = this.props;

        return (
            <>
                <DialogTitle className={classes.modalTitleContainer}>
                    <Grid container justify="center" direction="flex-end">
                        <Grid item>
                            <Typography>
                                <p className={classes.modalTitle}>REPORT AN ISSUE</p>
                            </Typography>
                            <IconButton
                                aria-label="close-modal"
                                className={classes.closeButton}
                                size="small"
                                onClick={() => {
                                    // if replace service is called, force refresh so ROSS Order fields can update
                                    if ((!isEmpty(replaceResponse) || !isEmpty(partialRefundResponse) || !isEmpty(partialRefundResponseError)) || isAvailable === false) {
                                        history.go();
                                    } else handleChangeModalState('replacement', 'closeWindow');
                                }}
                                onKeyDown={this.handleOnClick}
                                edge="end"
                            >
                                <CloseIcon />
                            </IconButton>
                        </Grid>
                    </Grid>
                </DialogTitle>
            </>
        );
    }

    renderFallbackUI = () => {
        const {
            classes, handleChangeModalState, replaceResponse, partialRefundResponse, partialRefundResponseError, history, isAvailable,
        } = this.props;
        const { error } = this.state;
        let errorMessage = '';
        const hasErrorState = error?.length > 0;
        switch (error) {
            case 'product not available':
                errorMessage = (
                    <>
                        <p>We’re sorry, this product is currently not available. </p>
                        <p>For immediate assistance, please click the CHAT icon.</p>
                    </>
                );
                break;
            default:
                errorMessage = (
                    <>
                        <p>Sorry, maintenance is in-progress.</p>
                        <p>For immediate assistance, please click the CHAT icon.</p>
                    </>
                );
        }

        return (
            <DialogContent className={classes.modalContentContainer}>
                <DialogContentText>
                    <p className={classes.modalBodyText}>{errorMessage}</p>
                </DialogContentText>
                <div className={classes.buttonsWrapper}>
                    <button
                        className={classes.CTAButton}
                        type="button"
                        onClick={() => {
                            // if replace, savings pass service is called, force refresh so ROSS Order fields can update
                            if ((!isEmpty(replaceResponse) || !isEmpty(partialRefundResponse) || !isEmpty(partialRefundResponseError) || hasErrorState) || isAvailable === false) {
                                history.go();
                            } else handleChangeModalState('replacement', 'closeWindow');
                        }}
                        onKeyDown={this.handleOnClick}
                    >
                        Close Window
                    </button>
                </div>
            </DialogContent>
        );
    }

    renderButtonText = (currentPage) => {
        const { productType } = this.props;
        const { issueProductType, isLoading, productIssue } = this.state;

        if (currentPage === 'page2' && issueProductType === 'floral') {
            if (isLoading) return this.renderLoadingIcon();
            return 'Submit';
        }
        if (currentPage === 'page3' && productType === 'FPT') {
            if (isLoading) return this.renderLoadingIcon();
            return 'Submit';
        }
        if (currentPage === 'page3' && productType === 'GPT' && issueProductType === 'food' && productIssue && productIssue !== 'broken-melted') {
            if (isLoading) return this.renderLoadingIcon();
            return 'Submit';
        }
        if (currentPage === 'page4') {
            if (isLoading) {
                return this.renderLoadingIcon();
            }
            return 'Submit';
        }
        return 'Next';
    }

    renderPage0 = () => {
      const {
          classes, history,
      } = this.props;

      /* BE LOGIC
          - ORDER OVER $300
             - cancelFlag = false
             - replacementFlag = false
             - partialCreditFlag = false
             - hasExceededCSITotalCharge = true
          - ORDER <= $20
             - partialCreditFlag = false
             - hasExceededCSIMinCharge = true
          - ORDER PLACED OVER 90 DAYS AGO
             - cancelFlag = false
             - replacementFlag = false
             - partialCreditFlag = false
             - hasExceededCSIDate = true
          - CUSTOMER REPLACED 3 TIMES IN 90 DAYS
             - replacementFlag = false
             - partialCreditFlag = false
             - hasExceededCSIThreshold = true
      */

      try {
          return (
              <>
                  <DialogContent className={classes.modalContentContainer}>
                      <div className={classes.modalInnerContent}>
                          <DialogContentText>
                              <p className={classes.modalBodyText}>We&apos;re sorry your experience didn&apos;t meet expectations.</p>
                              <p className={classes.modalBodyText}>If your order wasn&apos;t received or you have a billing concern, please contact us by clicking the CHAT icon.</p>
                              <p className={classes.modalBodyText}>If there was a Quality Issue (i.e. damaged), please click &apos;Proceed&apos;.</p>
                          </DialogContentText>
                      </div>
                      <div className={classes.buttonsWrapper}>
                          <button
                              className={classes.cancelButton}
                              type="button"
                              onClick={() => history.go()}
                              onKeyDown={this.handleOnClick}
                          >
                              Cancel
                          </button>
                          <button
                              className={classes.CTAButton}
                              type="button"
                              onClick={() => {
                                  this.handleClickProceed('page0', 'page1');
                              }}
                              onKeyDown={this.handleOnClick}
                          >
                              Proceed
                          </button>
                      </div>
                  </DialogContent>
              </>
          );
      } catch (ex) {
          mbpLogger.logError({
              appName: process.env.npm_package_name,
              component: 'ReplacementOrderModal',
              page: 'page0',
              jsError: ex,
          });
          return this.renderFallbackUI();
      }
    }

    renderPage1 = () => {
      const {
          classes,
          ROSSCSIFailureReason,
          isPartialCreditEnabled, // Flag that controls new flow for orders over $20
          isAvailable,
          isReplacementEnabled,
      } = this.props;
      const { validationFailed } = this.state;
      const {
          hasExceededCSIMinCharge,
      } = ROSSCSIFailureReason;

      const isOrderOver20 = hasExceededCSIMinCharge === false;
      const SavingsPassOnly = isPartialCreditEnabled && !isReplacementEnabled;
      const SavingsPassOver20 = isPartialCreditEnabled && isOrderOver20;

      try {
          return (
              <>
                  {SavingsPassOver20 || !isReplacementEnabled ? (
                      <DialogContent className={classes.modalContentContainer}>
                          <div className={classes.modalInnerContent}>
                              {!isAvailable || SavingsPassOnly ? (
                                  <DialogContentText>
                                      <p className={classes.modalBodyText}>We&apos;re sorry your order didn&apos;t meet expectations.</p>
                                      <p className={classes.modalBodyText}>We want to make this right. We can offer a 50% Refund and $20 Savings Pass, for a future purchase.</p>
                                      <p className={classes.modalBodyText}>Would you like to proceed?</p>
                                  </DialogContentText>
                              )
                                  : (
                                      <>
                                          <DialogContentText>
                                              <p className={classes.modalBodyText}>We&apos;re sorry your order didn&apos;t meet expectations. <span className={classes.breakOnMobile}>We want to make this right! Would you like a:</span></p>
                                          </DialogContentText>
                                          <FormHelperText>
                                              {
                                                  validationFailed ? this.renderValidationMsg() : null
                                              }
                                          </FormHelperText>
                                          <FormControl>
                                              <RadioGroup onChange={this.handleSelectValue}>
                                                  <FormControlLabel value="issueResolution:replacement" control={<Radio color="primary" />} label={<Typography className={classes.radioButtonsPage1}>Free redelivery of the same item to the same address</Typography>} />
                                                  <FormControlLabel value="issueResolution:savingspass" control={<Radio color="primary" />} label={<Typography className={classes.radioButtonsPage1}>50% Refund and $20 Savings Pass for a future purchase</Typography>} />
                                              </RadioGroup>
                                          </FormControl>
                                      </>
                                  )}
                          </div>
                          <div className={classes.buttonsWrapper}>
                              <button
                                  aria-label="cancel"
                                  className={classes.cancelButton}
                                  type="button"
                                  onClick={() => {
                                      this.handleClickProceed('page1', 'page0', 'issueResolution');
                                  }}
                                  onKeyDown={this.handleOnClick}
                              >
                                  Back
                              </button>
                              <button
                                  className={classes.CTAButton}
                                  type="button"
                                  onClick={() => {
                                      if (isPartialCreditEnabled && isReplacementEnabled) {
                                          // If product is not available we want to set issueResolution state to only use savings pass flow
                                          if (!isAvailable) {
                                              this.setState({ issueResolution: 'savingspass' });
                                          } else if (!this.handleValidateSelection() && isAvailable) {
                                              return null;
                                          }
                                      }
                                      if (isPartialCreditEnabled && !isReplacementEnabled) {
                                          this.setState({ issueResolution: 'savingspass' });
                                      }
                                      return this.handleClickProceed('page1', 'page2');
                                  }}
                                  onKeyDown={this.handleOnClick}
                              >
                                  Proceed
                              </button>
                          </div>
                      </DialogContent>
                  )
                      : (
                          <DialogContent className={classes.modalContentContainer}>
                              <div className={classes.modalInnerContent}>
                                  <DialogContentText>
                                      <p className={classes.modalBodyText}>We&apos;re sorry your order didn&apos;t meet expectations.</p>
                                      <p className={classes.modalBodyText}>I can issue a replacement order of the same item to the same address, free of charge.</p>
                                      <p className={classes.modalBodyText}>Would you like to proceed?</p>
                                  </DialogContentText>
                              </div>
                              <div className={classes.buttonsWrapper}>
                                  <button
                                      className={classes.cancelButton}
                                      type="button"
                                      onClick={() => {
                                          this.handleClickProceed('page1', 'page0', 'issueResolution');
                                      }}
                                      onKeyDown={this.handleOnClick}
                                  >
                                      Back
                                  </button>
                                  <button
                                      className={classes.CTAButton}
                                      type="button"
                                      onClick={() => {
                                          if (isPartialCreditEnabled && !isReplacementEnabled) {
                                              this.setState({ issueResolution: 'savingspass' });
                                          }
                                          if (isReplacementEnabled && !isPartialCreditEnabled) {
                                              this.setState({ issueResolution: 'replacement' });
                                          }
                                          this.handleClickProceed('page1', 'page2');
                                      }}
                                      onKeyDown={this.handleOnClick}
                                  >
                                      Proceed
                                  </button>
                              </div>
                          </DialogContent>
                      )}
              </>
          );
      } catch (ex) {
          mbpLogger.logError({
              appName: process.env.npm_package_name,
              component: 'ReplacementOrderModal',
              page: 'page1',
              jsError: ex,
          });
          return this.renderFallbackUI();
      }
    }

    renderPage2 = () => {
        const { classes } = this.props;
        const { issueProductType, issueResolution, validationFailed } = this.state;
        try {
            return (
                <DialogContent className={classes.modalContentContainer}>
                    <div className={classes.modalInnerContent}>
                        <DialogContentText>
                            <p className={classes.modalBodyText}>What type of product had an issue?</p>
                        </DialogContentText>
                        <FormHelperText>
                            {
                                validationFailed ? this.renderValidationMsg() : null
                            }
                        </FormHelperText>
                        <form>
                            <FormControl>
                                <RadioGroup onChange={this.handleSelectValue}>
                                    <FormControlLabel value="issueProductType:floral" control={<Radio color="primary" />} label={<Typography className={classes.radioButtons}>Flowers / Plants</Typography>} />
                                    <FormControlLabel value="issueProductType:container" control={<Radio color="primary" />} label={<Typography className={classes.radioButtons}>Container (vase, planter, basket)</Typography>} />
                                    <FormControlLabel value="issueProductType:food" control={<Radio color="primary" />} label={<Typography className={classes.radioButtons}>Food</Typography>} />
                                </RadioGroup>
                            </FormControl>
                        </form>
                    </div>
                    <div className={classes.buttonsWrapper}>
                        <button
                            className={classes.cancelButton}
                            type="button"
                            onClick={() => {
                                this.handleClickProceed('page2', 'page1', 'issueProductType');
                                this.handleClickProceed('', '', 'issueResolution');
                            }}
                            onKeyDown={this.handleOnClick}
                        >
                            Back
                        </button>
                        <button
                            className={classes.CTAButton}
                            type="button"
                            onClick={() => {
                                if (!this.handleValidateSelection()) {
                                    return null;
                                }
                                if (issueProductType === 'floral') {
                                    if (issueResolution === 'savingspass') {
                                        return this.handlePartialRefund();
                                    }
                                    this.handleSubmit();
                                } else {
                                    return this.handleClickProceed('page2', 'page3'); // container or food orders, select reason why need replacement
                                }
                                return null;
                            }}
                            onKeyDown={this.handleOnClick}
                        >
                            {this.renderButtonText('page2')}
                        </button>
                    </div>
                </DialogContent>
            );
        } catch (ex) {
            mbpLogger.logError({
                appName: process.env.npm_package_name,
                component: 'ReplacementOrderModal',
                page: 'page2',
                jsError: ex,
                module: 'Replacement Order Modal',
            });
            return this.renderFallbackUI();
        }
    }

    renderPage3 = () => {
        const {
            issueProductType, issueResolution, validationFailed, productIssue,
        } = this.state;
        const { productType, classes } = this.props;
        if (issueProductType === 'container') {
            try {
                return (
                    <DialogContent className={classes.modalContentContainer}>
                        <div className={classes.modalInnerContent}>
                            <DialogContentText>
                                <p className={classes.modalBodyText}>What was the issue?</p>
                            </DialogContentText>
                            <FormHelperText>
                                {
                                    validationFailed ? this.renderValidationMsg() : null
                                }
                            </FormHelperText>
                            <form>
                                <FormControl>
                                    <RadioGroup onChange={this.handleSelectValue}>
                                        <FormControlLabel className={classes.radioButtons} value="productIssue:broken-torn" control={<Radio color="primary" />} label={<Typography className={classes.radioButtons}>Broken / Torn</Typography>} />
                                        <FormControlLabel className={classes.radioButtons} value="productIssue:dirty-stained" control={<Radio color="primary" />} label={<Typography className={classes.radioButtons}>Dirty / Stained</Typography>} />
                                        <FormControlLabel className={classes.radioButtons} value="productIssue:something-else" control={<Radio color="primary" />} label={<Typography className={classes.radioButtons}>Something Else</Typography>} />
                                    </RadioGroup>
                                </FormControl>
                            </form>
                        </div>
                        <div className={classes.buttonsWrapper}>
                            <button
                                className={classes.cancelButton}
                                type="button"
                                onClick={() => { this.handleClickProceed('page3', 'page2', 'issueProductType'); this.handleClickProceed('', '', 'productIssue'); }}
                                onKeyDown={this.handleOnClick}
                            >
                                Back
                            </button>
                            <button
                                className={classes.CTAButton}
                                type="button"
                                onClick={() => {
                                    if (!this.handleValidateSelection()) {
                                        return null;
                                    }
                                    if (productIssue === 'something-else') {
                                        return this.handleClickProceed('page3', 'customerService');
                                    }
                                    if (productType === 'GPT') {
                                        return this.handleClickProceed('page3', 'page4');
                                    }
                                    if (productType === 'FPT') {
                                        if (issueResolution === 'savingspass') {
                                            return this.handlePartialRefund();
                                        }
                                        this.handleSubmit();
                                    }
                                    return null;
                                }}
                                onKeyDown={this.handleOnClick}
                            >
                                {this.renderButtonText('page3')}
                            </button>
                        </div>
                    </DialogContent>
                );
            } catch (ex) {
                mbpLogger.logError({
                    appName: process.env.npm_package_name,
                    component: 'ReplacementOrderModal',
                    page: 'page3 issueProductType container',
                    jsError: ex,
                    module: 'Replacement Order Modal',
                });
                return this.renderFallbackUI();
            }
        }
        if (issueProductType === 'food') {
            try {
                return (
                    <DialogContent className={classes.modalContentContainer}>
                        <div className={classes.modalInnerContent}>
                            <DialogContentText>
                                <p className={classes.modalBodyText}>What was the issue?</p>
                            </DialogContentText>
                            <FormHelperText>
                                {
                                    validationFailed ? this.renderValidationMsg() : null
                                }
                            </FormHelperText>
                            <form>
                                <FormControl>
                                    <RadioGroup onChange={this.handleSelectValue} className={classes.radioButtons}>
                                        <FormControlLabel className={classes.radioButtons} value="productIssue:broken-melted" control={<Radio color="primary" />} label={<Typography className={classes.radioButtons}>Broken / Melted</Typography>} />
                                        <FormControlLabel className={classes.radioButtons} value="productIssue:not-fresh" control={<Radio color="primary" />} label={<Typography className={classes.radioButtons}>Not Fresh (i.e. fruit)</Typography>} />
                                        <FormControlLabel className={classes.radioButtons} value="productIssue:date-expired" control={<Radio color="primary" />} label={<Typography className={classes.radioButtons}>Date Expired</Typography>} />
                                        <FormControlLabel className={classes.radioButtons} value="productIssue:incorrect-quantity" control={<Radio color="primary" />} label={<Typography className={classes.radioButtons}>Incorrect Quantity</Typography>} />
                                        <FormControlLabel className={classes.radioButtons} value="productIssue:something-else" control={<Radio color="primary" />} label={<Typography className={classes.radioButtons}>Something Else</Typography>} />
                                    </RadioGroup>
                                </FormControl>
                            </form>
                        </div>
                        <div className={classes.buttonsWrapper}>
                            <button
                                className={classes.cancelButton}
                                type="button"
                                onClick={() => { this.handleClickProceed('page3', 'page2', 'issueProductType'); this.handleClickProceed('', '', 'productIssue'); }}
                                onKeyDown={this.handleOnClick}
                            >
                                Back
                            </button>
                            <button
                                className={classes.CTAButton}
                                type="button"
                                onClick={() => {
                                    if (!this.handleValidateSelection()) {
                                        return null;
                                    }
                                    if (productIssue === 'something-else') {
                                        return this.handleClickProceed('page3', 'customerService');
                                    }
                                    if ((productType === 'FPT') || (productType === 'GPT' && productIssue !== 'broken-melted')) {
                                        if (issueResolution === 'savingspass') {
                                            return this.handlePartialRefund();
                                        }
                                        this.handleSubmit();
                                    } else {
                                        return this.handleClickProceed('page3', 'page4');
                                    }
                                    return null;
                                }}
                                onKeyDown={this.handleOnClick}
                            >
                                {this.renderButtonText('page3')}
                            </button>
                        </div>
                    </DialogContent>
                );
            } catch (ex) {
                mbpLogger.logError({
                    appName: process.env.npm_package_name,
                    component: 'ReplacementOrderModal',
                    page: 'page3 issueProductType food',
                    jsError: ex,
                    module: 'Replacement Order Modal',
                });
                return this.renderFallbackUI();
            }
        }
        return null;
    }

    renderPage4 = () => {
        const { classes } = this.props;
        const { issueProductType, issueResolution, validationFailed } = this.state;
        return (
            <>
                <DialogContent className={classes.modalContentContainer}>
                    <div className={classes.modalInnerContent}>
                        <DialogContentText>
                            <p className={classes.modalBodyText}>Was the shipping box damaged?</p>
                        </DialogContentText>
                        <FormHelperText>
                            {
                                validationFailed ? this.renderValidationMsg() : null
                            }
                        </FormHelperText>
                        <form>
                            <FormControl>
                                <RadioGroup onChange={this.handleSelectValue}>
                                    <FormControlLabel value="shippingDamaged:no" control={<Radio color="primary" />} label={<Typography className={classes.radioButtons}>Shipping box was NOT damaged</Typography>} />
                                    <FormControlLabel value="shippingDamaged:yes" control={<Radio color="primary" />} label={<Typography className={classes.radioButtons}>Shipping box was damaged</Typography>} />
                                </RadioGroup>
                            </FormControl>
                        </form>
                    </div>
                    <div className={classes.buttonsWrapper}>
                        <button
                            className={classes.cancelButton}
                            type="button"
                            onClick={() => {
                                // both cases below are for GPT productTypes because FPT cannot arrive at page4 (shipping damage screen)
                                if (issueProductType === 'floral') {
                                    this.handleClickProceed('page4', 'page2', 'issueProductType');
                                }
                                if (issueProductType === 'container' || issueProductType === 'food') {
                                 this.handleClickProceed('page4', 'page3', 'productIssue');
                                 this.handleClickProceed('', '', 'shippingDamaged');
                              }
                              return null;
                            }}
                            onKeyDown={this.handleOnClick}
                        >
                            Back
                        </button>
                        <button
                            className={classes.CTAButton}
                            type="button"
                            onClick={() => {
                                if (!this.handleValidateSelection()) {
                                    return null;
                                }
                                if (issueResolution === 'savingspass') {
                                    return this.handlePartialRefund();
                                }
                                return this.handleSubmit();
                            }}
                            onKeyDown={this.handleOnClick}
                        >
                            {this.renderButtonText('page4')}
                        </button>
                    </div>
                </DialogContent>
            </>
        );
    }

    renderResolutionPage = (isSubmitted = true) => {
        const {
            classes, handleChangeModalState, replaceResponse, history, isAvailable,
        } = this.props;
        const { issueResolution } = this.state;

        return (
            <DialogContent className={classes.modalContentContainer}>
                <DialogContentText>
                    {!isSubmitted && (
                        <div className={classes.modalInnerContent}>
                            <p className={classes.modalBodyText}>Please contact Customer Service for assistance.</p>
                        </div>
                    )}
                    {isSubmitted && issueResolution === 'savingspass' && (
                        <div className={classes.modalInnerContent}>
                            <p className={classes.modalBodyText}>A refund of 50% of the total charge will be processed and applied to your original payment method in 1 to 2 billing cycles.</p>
                            <p className={classes.modalBodyText}>A $20 Savings Pass for a future purchase, will be emailed to you.</p>
                        </div>
                    )}
                    {isSubmitted && issueResolution !== 'savingspass' && (
                        <div className={classes.modalInnerContent}>
                            <p className={classes.modalBodyText}>A replacement order has been placed, free of charge.</p>
                            <p className={classes.modalBodyText}>It will be delivered to the same address, on the next standard shipping day.</p>
                            <p className={classes.modalBodyText}>You will receive an Order Confirmation email shortly.</p>
                        </div>
                    )}
                </DialogContentText>
                <div className={classes.buttonsWrapper}>
                    <button
                        className={classes.CTAButton}
                        type="button"
                        onClick={() => {
                            // if replace service is called, force refresh so ROSS Order fields can update
                            if (!isEmpty(replaceResponse) || isAvailable === false) {
                                history.go();
                            } else handleChangeModalState('replacement','closeWindow');
                        }}
                        onKeyDown={this.handleOnClick}
                    >
                        Close Window
                    </button>
                </div>
            </DialogContent>
        );
    }

    renderLoadingIcon = () => {
        const { isLoading } = this.state;
        const { classes, isAvailable, replaceResponse, partialRefundResponse } = this.props;
        // button loading icon if product availability has a value
        if (((isLoading && isAvailable !== null) && (isEmpty(replaceResponse) && isEmpty(partialRefundResponse)))) {
            return (
                <>
                    <CircularProgress color="inherit" size={14} />
                </>
            );
        }

        // full width loader on first render only
        if (isLoading && isAvailable === null) {
            return (
                <DialogContent className={classes.modalContentContainer}>
                    <div className={classes.loaderContainer}>
                        <CircularProgress color="inherit" size={25} />
                    </div>
                </DialogContent>
            );
        }
        return null;
    }

    renderValidationMsg = () => {
        const { classes } = this.props;
        return (
            <>
                <p className={classes.validationMsg}>Please select an option to continue.</p>
            </>
        );
    }

    generateReplacementPayload = () => {
      // call this function when about to call the api
      const {
          ROSSOrder,
          productType,
          startTime,
          ssrDeviceType,
          ROSSOrderNumber,
      } = this.props;
      const {
          issueProductType, // floral, container, food
          productIssue, // broken / melted, torn, etc
          shippingDamaged,
      } = this.state;
      const orderNumber = ROSSOrderNumber;
      const tiEmail = ROSSOrder?.billingProfile.emailAddress;
      const deviceType = ssrDeviceType;
      const productBrand = ROSSOrder?.items?.[0]?.productBrand
      const resolutionBrand = Helper.generateFloralResolutionBrand(productBrand)
      const todaysDate = new Date().toISOString().substring(0, 10);
      const deliveryDate = ROSSOrder.history.find((histObj) => histObj.codeStatus === 'DL')?.createdDate?.substring(0, 10) || '';
      const fallbackDeliveryDate = ROSSOrder.items[0].deliveryDate?.substring(0, 10) || '';
      if (!deliveryDate && !fallbackDeliveryDate) {
          this.setState({ error: 'generic' });
      }

      switch (issueProductType) {
          case 'floral':
              // if more than 7 days, GPT and FPT are coded the same
              if (this.isMoreThan7Days(todaysDate, (deliveryDate || fallbackDeliveryDate))) { // GPT and FPT more than 7 days
                  return {
                      deviceType,
                      orderNumber,
                      tiEmail,
                      startTime,
                      resolutionBrand,
                      msgFlorist: 'N',
                      problemCode: 'Q',
                      detailCode: 'FP',
                      reasonCode: 'DWD',
                      resCode: '278',
                      suggestResCode: 'EG',
                      statusCode: 'X',
                      faultCode: 'R',
                      errorCode: 'P',
                      suggestedResId: '312',
                  };
              }
              if (productType === 'FPT') { // FPT and less than 7 days
                  // FPT and less than 7 days
                  return {
                      deviceType,
                      orderNumber,
                      tiEmail,
                      startTime,
                      resolutionBrand,
                      msgFlorist: 'Y',
                      problemCode: 'Q',
                      detailCode: 'FP',
                      reasonCode: 'DWD',
                      resCode: '276',
                      suggestResCode: 'EG',
                      statusCode: 'X',
                      faultCode: 'F',
                      errorCode: 'P',
                      suggestedResId: '312',
                  };
              }
              if (productType === 'GPT') { // GPT and less than 7 days
                  return {
                      deviceType,
                      orderNumber,
                      tiEmail,
                      startTime,
                      resolutionBrand,
                      msgFlorist: 'N',
                      problemCode: 'Q',
                      detailCode: 'FP',
                      reasonCode: 'DWD',
                      resCode: '280',
                      suggestResCode: 'EG',
                      statusCode: 'X',
                      faultCode: 'V',
                      errorCode: 'P',
                      suggestedResId: '312',
                  };
              }
              this.setState({ error: 'generic' });
              break;
          case 'container':
              if (productType === 'GPT') { // GPT not same case for broken and dirty
                  if (shippingDamaged === 'yes') {
                      if (productIssue === 'dirty-stained') {
                          return {
                              deviceType,
                              orderNumber,
                              tiEmail,
                              startTime,
                              resolutionBrand,
                              msgFlorist: 'N',
                              problemCode: 'Q',
                              detailCode: 'CN',
                              reasonCode: 'SDD',
                              resCode: '256',
                              suggestResCode: 'EG',
                              statusCode: 'X',
                              faultCode: 'H',
                              errorCode: 'P',
                              suggestedResId: '312',
                          };
                      }

                      return {
                          deviceType,
                          orderNumber,
                          tiEmail,
                          startTime,
                          resolutionBrand,
                          msgFlorist: 'N',
                          problemCode: 'Q',
                          detailCode: 'CN',
                          reasonCode: 'BTD',
                          resCode: '236',
                          suggestResCode: 'EG',
                          statusCode: 'X',
                          faultCode: 'H',
                          errorCode: 'P',
                          suggestedResId: '312',
                      };
                  }
                  if (shippingDamaged === 'no') {
                      if (productIssue === 'dirty-stained') {
                          return {
                              deviceType,
                              orderNumber,
                              tiEmail,
                              startTime,
                              resolutionBrand,
                              msgFlorist: 'N',
                              problemCode: 'Q',
                              detailCode: 'CN',
                              reasonCode: 'SDN',
                              resCode: '258',
                              suggestResCode: 'EG',
                              statusCode: 'X',
                              faultCode: 'V',
                              errorCode: 'P',
                              suggestedResId: '312',
                          };
                      }

                      return {
                          deviceType,
                          orderNumber,
                          tiEmail,
                          startTime,
                          resolutionBrand,
                          msgFlorist: 'N',
                          problemCode: 'Q',
                          detailCode: 'CN',
                          reasonCode: 'BTN',
                          resCode: '238',
                          suggestResCode: 'EG',
                          statusCode: 'X',
                          faultCode: 'V',
                          errorCode: 'P',
                          suggestedResId: '312',
                      };
                  }
              }
              if (productType === 'FPT') {
                  if (productIssue === 'dirty-stained') {
                      return {
                          deviceType,
                          orderNumber,
                          tiEmail,
                          startTime,
                          resolutionBrand,
                          msgFlorist: 'Y',
                          problemCode: 'Q',
                          detailCode: 'CN',
                          reasonCode: 'SDY',
                          resCode: '254',
                          suggestResCode: 'EG',
                          statusCode: 'X',
                          faultCode: 'F',
                          errorCode: 'P',
                          suggestedResId: '312',
                      };
                  }
                  if (productIssue === 'broken-torn') {
                      return {
                          deviceType,
                          orderNumber,
                          tiEmail,
                          startTime,
                          resolutionBrand,
                          msgFlorist: 'Y',
                          problemCode: 'Q',
                          detailCode: 'CN',
                          reasonCode: 'BKT',
                          resCode: '234',
                          suggestResCode: 'EG',
                          statusCode: 'X',
                          faultCode: 'F',
                          errorCode: 'P',
                          suggestedResId: '312',
                      };
                  }
              }
              this.setState({ error: 'generic' });
              break;
          case 'food':
              if (productType === 'GPT') {
                  if (productIssue === 'date-expired') { // cases unaffected by shipping damage
                      return {
                          deviceType,
                          orderNumber,
                          tiEmail,
                          startTime,
                          resolutionBrand,
                          msgFlorist: 'N',
                          problemCode: 'Q',
                          detailCode: 'FF',
                          reasonCode: 'EXP',
                          resCode: '322',
                          suggestResCode: 'EG',
                          statusCode: 'X',
                          faultCode: 'V',
                          errorCode: 'P',
                          suggestedResId: '312',
                      };
                  }
                  if (productIssue === 'incorrect-quantity') { // cases unaffected by shipping damage
                      return {
                          deviceType,
                          orderNumber,
                          tiEmail,
                          startTime,
                          resolutionBrand,
                          msgFlorist: 'N',
                          problemCode: 'Q',
                          detailCode: 'FF',
                          reasonCode: 'LPV',
                          resCode: '332',
                          suggestResCode: 'EG',
                          statusCode: 'X',
                          faultCode: 'V',
                          errorCode: 'P',
                          suggestedResId: '312',
                      };
                  }
                  if (productIssue === 'not-fresh') {
                      return {
                          deviceType,
                          orderNumber,
                          tiEmail,
                          startTime,
                          resolutionBrand,
                          msgFlorist: 'N',
                          problemCode: 'Q',
                          detailCode: 'FF',
                          reasonCode: 'NSM',
                          resCode: '336',
                          suggestResCode: 'EG',
                          statusCode: 'X',
                          faultCode: 'V',
                          errorCode: 'P',
                          suggestedResId: '312',
                      };
                  }
                  if (shippingDamaged === 'yes') {
                      return {
                          deviceType,
                          orderNumber,
                          tiEmail,
                          startTime,
                          resolutionBrand,
                          msgFlorist: 'N',
                          problemCode: 'Q',
                          detailCode: 'FF',
                          reasonCode: 'BTD',
                          resCode: '316',
                          suggestResCode: 'EG',
                          statusCode: 'X',
                          faultCode: 'H',
                          errorCode: 'P',
                          suggestedResId: '312',
                      };
                  }
                  if (shippingDamaged === 'no') {
                      return {
                          deviceType,
                          orderNumber,
                          tiEmail,
                          startTime,
                          resolutionBrand,
                          msgFlorist: 'N',
                          problemCode: 'Q',
                          detailCode: 'FF',
                          reasonCode: 'BTN',
                          resCode: '318',
                          suggestResCode: 'EG',
                          statusCode: 'X',
                          faultCode: 'V',
                          errorCode: 'P',
                          suggestedResId: '312',
                      };
                  }
              }
              if (productType === 'FPT') {
                  if (productIssue === 'broken-melted') {
                      return {
                          deviceType,
                          orderNumber,
                          tiEmail,
                          startTime,
                          resolutionBrand,
                          msgFlorist: 'Y',
                          problemCode: 'Q',
                          detailCode: 'FF',
                          reasonCode: 'BKT',
                          resCode: '314',
                          suggestResCode: 'EG',
                          statusCode: 'X',
                          faultCode: 'F',
                          errorCode: 'P',
                          suggestedResId: '312',
                      };
                  }
                  if (productIssue === 'not-fresh') {
                      return {
                          deviceType,
                          orderNumber,
                          tiEmail,
                          startTime,
                          resolutionBrand,
                          msgFlorist: 'Y',
                          problemCode: 'Q',
                          detailCode: 'FF',
                          reasonCode: 'NSM',
                          resCode: '334',
                          suggestResCode: 'EG',
                          statusCode: 'X',
                          faultCode: 'F',
                          errorCode: 'P',
                          suggestedResId: '312',
                      };
                  }
                  if (productIssue === 'date-expired') {
                      // FPT case
                      return {
                          deviceType,
                          orderNumber,
                          tiEmail,
                          startTime,
                          resolutionBrand,
                          msgFlorist: 'Y',
                          problemCode: 'Q',
                          detailCode: 'FF',
                          reasonCode: 'EXP',
                          resCode: '320',
                          suggestResCode: 'EG',
                          statusCode: 'X',
                          faultCode: 'F',
                          errorCode: 'P',
                          suggestedResId: '312',
                      };
                  }
                  if (productIssue === 'incorrect-quantity') {
                      return {
                          deviceType,
                          orderNumber,
                          tiEmail,
                          startTime,
                          resolutionBrand,
                          msgFlorist: 'Y',
                          problemCode: 'Q',
                          detailCode: 'FF',
                          reasonCode: 'LPV',
                          resCode: '330',
                          suggestResCode: 'EG',
                          statusCode: 'X',
                          faultCode: 'F',
                          errorCode: 'P',
                          suggestedResId: '312',
                      };
                  }
              }
              this.setState({ error: 'generic' });
              break;
          default:
              this.setState({ error: 'generic' });
              break;
      }
      return null;
    }

    generateSavingsPassPayload = () => {
         const {
            ROSSOrder,
            productType,
            startTime,
            ssrDeviceType,
            ROSSOrderNumber,
         } = this.props;

         const {
            issueProductType, // floral, container, food
            productIssue, // broken / melted, torn, etc
            shippingDamaged,
         } = this.state;

         const orderNumber = ROSSOrderNumber;
         const tiEmail = ROSSOrder?.billingProfile.emailAddress;
         const deviceType = ssrDeviceType;
         const productBrand = ROSSOrder?.items?.[0]?.productBrand
         const resolutionBrand = Helper.generateFloralResolutionBrand(productBrand)
         const todaysDate = new Date().toISOString().substring(0, 10);
         const deliveryDate = ROSSOrder.history.find((histObj) => histObj.codeStatus === 'DL')?.createdDate?.substring(0, 10) || '';
         const fallbackDeliveryDate = ROSSOrder.items[0].deliveryDate?.substring(0, 10) || '';
         if (!deliveryDate && !fallbackDeliveryDate) {
            this.setState({ error: 'generic' });
         }

         switch (issueProductType) {
            case 'floral':
               if (productType === 'FPT') {
                     if (this.isMoreThan7Days(todaysDate, (deliveryDate || fallbackDeliveryDate))) {
                        return {
                           deviceType,
                           orderNumber,
                           tiEmail,
                           startTime,
                           resolutionBrand,
                           msgFlorist: 'Y',
                           problemCode: 'Q',
                           detailCode: 'FP',
                           reasonCode: 'DWD',
                           resCode: '278',
                           suggestResCode: 'PG',
                           statusCode: 'X',
                           faultCode: 'L',
                           errorCode: 'P',
                           suggestedResId: '322',
                        };
                     }

                     if (productType === 'FPT') {
                        return {
                           deviceType,
                           orderNumber,
                           tiEmail,
                           startTime,
                           resolutionBrand,
                           msgFlorist: 'Y',
                           problemCode: 'Q',
                           detailCode: 'FP',
                           reasonCode: 'DWD',
                           resCode: '276',
                           suggestResCode: 'PG',
                           statusCode: 'X',
                           faultCode: 'F',
                           errorCode: 'P',
                           suggestedResId: '322',
                        };
                     }
               }

               if (productType === 'GPT') {
                     return {
                        deviceType,
                        orderNumber,
                        tiEmail,
                        startTime,
                        resolutionBrand,
                        msgFlorist: 'N',
                        problemCode: 'Q',
                        detailCode: 'FP',
                        reasonCode: 'DWD',
                        resCode: '278',
                        suggestResCode: 'PG',
                        statusCode: 'X',
                        faultCode: 'V',
                        errorCode: 'P',
                        suggestedResId: '322',
                     };
               }
               this.setState({ error: 'generic' });
               break;
            case 'container': {
               if (productType === 'FPT') {
                     if (productIssue === 'broken-torn') {
                        return {
                           deviceType,
                           orderNumber,
                           tiEmail,
                           startTime,
                           resolutionBrand,
                           msgFlorist: 'Y',
                           problemCode: 'Q',
                           detailCode: 'CN',
                           reasonCode: 'BKT',
                           resCode: '234',
                           suggestResCode: 'PG',
                           statusCode: 'X',
                           faultCode: 'F',
                           errorCode: 'P',
                           suggestedResId: '322',
                        };
                     }

                     // K //
                     if (productIssue === 'dirty-stained') {
                        return {
                           deviceType,
                           orderNumber,
                           tiEmail,
                           startTime,
                           resolutionBrand,
                           msgFlorist: 'Y',
                           problemCode: 'Q',
                           detailCode: 'CN',
                           reasonCode: 'SDY',
                           resCode: '254',
                           suggestResCode: 'PG',
                           statusCode: 'X',
                           faultCode: 'F',
                           errorCode: 'P',
                           suggestedResId: '322',
                        };
                     }
               }

               if (productType === 'GPT') {
                     if (productIssue === 'broken-torn') {
                        if (shippingDamaged === 'yes') {
                           return {
                                 deviceType,
                                 orderNumber,
                                 tiEmail,
                                 startTime,
                                 resolutionBrand,
                                 msgFlorist: 'N',
                                 problemCode: 'Q',
                                 detailCode: 'CN',
                                 reasonCode: 'BTD',
                                 resCode: '236',
                                 suggestResCode: 'PG',
                                 statusCode: 'X',
                                 faultCode: 'H',
                                 errorCode: 'P',
                                 suggestedResId: '322',
                           };
                        }
                        return {
                           deviceType,
                           orderNumber,
                           tiEmail,
                           startTime,
                           resolutionBrand,
                           msgFlorist: 'N',
                           problemCode: 'Q',
                           detailCode: 'CN',
                           reasonCode: 'BTN',
                           resCode: '238',
                           suggestResCode: 'PG',
                           statusCode: 'X',
                           faultCode: 'V',
                           errorCode: 'P',
                           suggestedResId: '322',
                        };
                     }

                     if (productIssue === 'dirty-stained') {
                        if (shippingDamaged === 'yes') {
                           return {
                                 deviceType,
                                 orderNumber,
                                 tiEmail,
                                 startTime,
                                 resolutionBrand,
                                 msgFlorist: 'N',
                                 problemCode: 'Q',
                                 detailCode: 'CN',
                                 reasonCode: 'SDD',
                                 resCode: '256',
                                 suggestResCode: 'PG',
                                 statusCode: 'X',
                                 faultCode: 'H',
                                 errorCode: 'P',
                                 suggestedResId: '322',
                           };
                        }

                        return {
                           deviceType,
                           orderNumber,
                           tiEmail,
                           startTime,
                           resolutionBrand,
                           msgFlorist: 'N',
                           problemCode: 'Q',
                           detailCode: 'CN',
                           reasonCode: 'SDN',
                           resCode: '258',
                           suggestResCode: 'PG',
                           statusCode: 'X',
                           faultCode: 'V',
                           errorCode: 'P',
                           suggestedResId: '322',
                        };
                     }
               }

               this.setState({ error: 'generic' });
               break;
            }

            // FOOD
            case 'food': {
               if (productType === 'FPT') {
                     if (productIssue === 'broken-melted') {
                        return {
                           deviceType,
                           orderNumber,
                           tiEmail,
                           startTime,
                           resolutionBrand,
                           msgFlorist: 'Y',
                           problemCode: 'Q',
                           detailCode: 'FF',
                           reasonCode: 'BKT',
                           resCode: '314',
                           suggestResCode: 'PG',
                           statusCode: 'X',
                           faultCode: 'F',
                           errorCode: 'P',
                           suggestedResId: '322',
                        };
                     }

                     if (productIssue === 'not-fresh') {
                        return {
                           deviceType,
                           orderNumber,
                           tiEmail,
                           startTime,
                           resolutionBrand,
                           msgFlorist: 'Y',
                           problemCode: 'Q',
                           detailCode: 'FF',
                           reasonCode: 'NSM',
                           resCode: '334',
                           suggestResCode: 'PG',
                           statusCode: 'X',
                           faultCode: 'F',
                           errorCode: 'P',
                           suggestedResId: '322',
                        };
                     }

                     // S //
                     if (productIssue === 'date-expired') {
                        return {
                           deviceType,
                           orderNumber,
                           tiEmail,
                           startTime,
                           resolutionBrand,
                           msgFlorist: 'Y',
                           problemCode: 'Q',
                           detailCode: 'FF',
                           reasonCode: 'EXP',
                           resCode: '320',
                           suggestResCode: 'PG',
                           statusCode: 'X',
                           faultCode: 'F',
                           errorCode: 'P',
                           suggestedResId: '322',
                        };
                     }

                     // U //
                     if (productIssue === 'incorrect-quantity') {
                        return {
                           deviceType,
                           orderNumber,
                           tiEmail,
                           startTime,
                           resolutionBrand,
                           msgFlorist: 'Y',
                           problemCode: 'Q',
                           detailCode: 'FF',
                           reasonCode: 'LPV',
                           resCode: '330',
                           suggestResCode: 'PG',
                           statusCode: 'X',
                           faultCode: 'F',
                           errorCode: 'P',
                           suggestedResId: '322',
                        };
                     }
               }

               if (productType === 'GPT') {
                     // O //
                     if (productIssue === 'broken-melted') {
                        if (shippingDamaged === 'yes') {
                           return {
                                 deviceType,
                                 orderNumber,
                                 tiEmail,
                                 startTime,
                                 resolutionBrand,
                                 msgFlorist: 'N',
                                 problemCode: 'Q',
                                 detailCode: 'FF',
                                 reasonCode: 'BTD',
                                 resCode: '316',
                                 suggestResCode: 'PG',
                                 statusCode: 'X',
                                 faultCode: 'H',
                                 errorCode: 'P',
                                 suggestedResId: '322',
                           };
                        }

                        return {
                           deviceType,
                           orderNumber,
                           tiEmail,
                           startTime,
                           resolutionBrand,
                           msgFlorist: 'N',
                           problemCode: 'Q',
                           detailCode: 'FF',
                           reasonCode: 'BTN',
                           resCode: '318',
                           suggestResCode: 'PG',
                           statusCode: 'X',
                           faultCode: 'V',
                           errorCode: 'P',
                           suggestedResId: '322',
                        };
                     }

                     if (productIssue === 'not-fresh') {
                        return {
                           deviceType,
                           orderNumber,
                           tiEmail,
                           startTime,
                           resolutionBrand,
                           msgFlorist: 'N',
                           problemCode: 'Q',
                           detailCode: 'FF',
                           reasonCode: 'NSM',
                           resCode: '336',
                           suggestResCode: 'PG',
                           statusCode: 'X',
                           faultCode: 'V',
                           errorCode: 'P',
                           suggestedResId: '322',
                        };
                     }

                     if (productIssue === 'date-expired') {
                        return {
                           deviceType,
                           orderNumber,
                           tiEmail,
                           startTime,
                           resolutionBrand,
                           msgFlorist: 'N',
                           problemCode: 'Q',
                           detailCode: 'FF',
                           reasonCode: 'EXP',
                           resCode: '322',
                           suggestResCode: 'PG',
                           statusCode: 'X',
                           faultCode: 'V',
                           errorCode: 'P',
                           suggestedResId: '322',
                        };
                     }

                     if (productIssue === 'incorrect-quantity') {
                        return {
                           deviceType,
                           orderNumber,
                           tiEmail,
                           startTime,
                           resolutionBrand,
                           msgFlorist: 'N',
                           problemCode: 'Q',
                           detailCode: 'FF',
                           reasonCode: 'LPV',
                           resCode: '332',
                           suggestResCode: 'PG',
                           statusCode: 'X',
                           faultCode: 'V',
                           errorCode: 'P',
                           suggestedResId: '322',
                        };
                     }
               }

               this.setState({ error: 'generic' });
               break;
            }
            default:
               this.setState({ error: 'generic' });
               break;
         }
         return null;
    }

    isMoreThan7Days = (todaysDate, deliveryDate) => { // fn returns false for 7 days or less
        const parsedTodaysDate = todaysDate.split('-');
        const parsedDeliveryDate = deliveryDate.split('-');
        return differenceInDays(new Date(parsedTodaysDate[0], parsedTodaysDate[1], parsedTodaysDate[2]), new Date(parsedDeliveryDate[0], parsedDeliveryDate[1], parsedDeliveryDate[2])) > 7;
    }

    render() {
        const {
            classes,
            replaceResponse = {},
            // response from refund endpoint
            // refundResponse = {},
            partialRefundResponse = {},
            partialRefundResponseError = {},
            isAvailable,
            isPartialCreditEnabled,
        } = this.props;
        const {
            page0,
            page1,
            page2,
            page3,
            page4,
            error,
            isLoading,
            customerService,
        } = this.state;

        return (
            <>
                <Dialog fullWidth open maxWidth="sm" name="replacement-modal">
                    {this.renderHeaderComponent(classes)}
                    {
                        ((isLoading && isAvailable === null) || ((isEmpty(replaceResponse) || isEmpty(partialRefundResponse)))) && this.renderLoadingIcon()
                    }
                    {
                        // introduction page confirming the user wnats to proceed with one of report an issue flows.
                        (isEmpty(replaceResponse) || isEmpty(partialRefundResponse)) && page0 ? this.renderPage0() : null
                    }
                    {
                        // introduction page confirming the user wnats to replace their order.
                        (isEmpty(replaceResponse) || isEmpty(partialRefundResponse)) && page1 ? this.renderPage1() : null
                    }
                    {
                        // asks which type of product has a problem, e.g. flowers, food, or container.
                        (isEmpty(replaceResponse) && isEmpty(partialRefundResponse) && isEmpty(partialRefundResponseError)) && page2 ? this.renderPage2() : null
                    }
                    {
                        // asks what the issue was with the product, e.g. broken, dirty.
                        (isEmpty(replaceResponse) && isEmpty(partialRefundResponse) && isEmpty(partialRefundResponseError)) && page3 ? this.renderPage3() : null
                    }
                    {
                        // for FPT and GPT items, it will show contact customer service page if something else option is chosen
                        (isEmpty(replaceResponse) || isEmpty(partialRefundResponse)) && customerService ? this.renderResolutionPage(false) : null
                    }
                    {
                        // only for GPT items, asks if the shipping box was damaged or not.
                        (isEmpty(replaceResponse) && isEmpty(partialRefundResponse) && isEmpty(partialRefundResponseError)) && page4 ? this.renderPage4() : null
                    }
                    {
                        // page confirms that a replacement order has been issued
                        replaceResponse.replaceOrder === true || partialRefundResponse.message === 'Valid Message' ? this.renderResolutionPage(true) : null
                    }
                    {
                        // fall back to error page if anything goes wrong
                        (
                            replaceResponse.message === 'More than one additional order found'
                            || replaceResponse.message === 'This order can\'t be replaced'
                            || replaceResponse.message === 'Replacement not allowed on this brand'
                            || !isEmpty(partialRefundResponseError)
                            || replaceResponse.replaceOrder === false
                            || replaceResponse.replaceOrder === null
                            || error !== ''
                            || (isAvailable === false && !isPartialCreditEnabled)
                        ) ? this.renderFallbackUI() : null
                    }
                </Dialog>
            </>
        );
    }
}

ReplacementOrderModal.defaultProps = {
    replaceResponse: {},
    refundResponse: {},
    partialRefundResponse: {},
    history: {},
    isAvailable: null,
    availabilityError: '',
};

ReplacementOrderModal.propTypes = {
    classes: object.isRequired,
    handleChangeModalState: func.isRequired,
    productType: string.isRequired,
    startTime: string.isRequired,
    ROSSOrder: shape({
        brandId: string,
        modifiedDateTime: string,
        orderNumber: string,
        orders: arrayOf(shape({
            actualDeliveryDate: string,
            address: string,
            carrier: string,
            courier: string,
            createdDate: string,
            currentLocation: object,
            deliveryDate: string,
            deliveryImageURL: string,
            deliveryMethod: string,
            deliveryNotes: string,
            history: arrayOf(shape({
                codeStatus: string,
                createdDate: string,
                location: object,
                status: string,
                statusDescription: string,
            })),
            intOrderNumber: string,
        })),
        items: arrayOf(shape({
            productBrand: string,
            itemType: string,
            productName: string,
            productSku: string,
        })),
        origin: string,
        recipientFirstName: string,
        recipientLastName: string,
        signatureImageURL: string,
        status: string,
        statusDescription: string,
        trackingNumber: string,
        type: string,
        warningMessage: string,
    }).isRequired,
    replaceOrder: func.isRequired,
    partialRefund: func.isRequired,
    replaceResponse: shape({
        replaceOrder: bool.isRequired,
        message: string.isRequired,
    }),
    refundResponse: shape({
      refundOrder: bool.isRequired,
      message: string.isRequired,
    }),
    partialRefundResponse: shape({
        message: string.isRequired,
    }),
    partialRefundResponseError: object.isRequired,
    ssrDeviceType: string.isRequired,
    ROSSOrderNumber: string.isRequired,
    history: shape({
        go: func.isRequired,
    }),
    isAvailable: bool,
    checkProductAvailability: func.isRequired,
    availabilityError: string,
    isPartialCreditEnabled: bool.isRequired,
    isReplacementEnabled: bool.isRequired,
    ROSSCSIFailureReason: bool.isRequired,
};

const mapStateToProps = (state) => {
    /* istanbul ignore next */
    const newState = state[PERSIST_KEY] ? state[PERSIST_KEY] : state;

    return {
        replaceResponse: newState.replaceResponse,
        partialRefundResponse: newState.partialRefundResponse,
        partialRefundResponseError: newState.partialRefundResponseError,
        ssrDeviceType: getSSRDeviceType(state),
        isAvailable: newState.isAvailable,
        availabilityError: newState.availabilityError,
    };
};

const mapDispatchToProps = (dispatch) => ({
    replaceOrder: (data) => dispatch(EventDispatcher.handleProcessReplaceOrder(data)),
    refundOrder: (data) => dispatch(EventDispatcher.handleProcessRefundOrder(data)),
    partialRefund: (data) => dispatch(EventDispatcher.handleProcessPartialRefund(data)),
    checkProductAvailability: (data) => dispatch(EventDispatcher.handleProcessCheckAvailability(data)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(ReplacementOrderModal)));
